const minZoom = 0.1;
const maxZoom = 5;
const zoomStep = 0.1;

export { minZoom, maxZoom, zoomStep };
